import React, { useEffect, useRef } from "react";
import { scrollTop } from "_common/_utils/ScrollTop";
import { PROPERTY_VIEW_STYLE } from "properties/components/BREAKPOINTS_SECTION_CARDS";
import { observer } from "mobx-react-lite";
import { cn } from "_configs/twconfig";
import { useCommunitiesPageContext } from "communities/communities-listing/communities-view-context";
import { useCommunitiesStore } from "communities/communities-listing/communities-page-context";
import { CommunitiesViewList } from "communities/communities-listing/_components/communities-view-list";
import { CommunitiesViewButtonMobile } from "communities/communities-listing/_components/communities-view-button-mobile";
import { CommunitiesViewMap } from "communities/communities-listing/_components/maps/communities-view-map";

export const CommunitiesView = observer(() => {
    const communitiesStore = useCommunitiesStore();
    const { mapOrListSelected } = useCommunitiesPageContext();
    const resultsContainer = useRef<HTMLDivElement>(null);
    const listStore = communitiesStore.getListStore("communities");
    useEffect(() => {
        setTimeout(() => {
            if (resultsContainer && resultsContainer?.current?.scrollTop) {
                scrollTop(resultsContainer, resultsContainer.current.scrollTop);
            }
        }, 250);
    }, [mapOrListSelected, listStore.selectedPage]);

    return (
        <div
            className={cn("flex flex-col md:flex-row flex-1 relative", {
                "mb-14": mapOrListSelected === PROPERTY_VIEW_STYLE.LIST,
            })}
        >
            <div
                ref={resultsContainer}
                className={cn("flex flex-col px-2", {
                    "h-[calc(100vh-var(--height-navbarNew)-var(--height-searchBar)-1px)] overflow-y-auto":
                        mapOrListSelected === PROPERTY_VIEW_STYLE.MAP,
                    "w-0 hidden md:w-1/2 md:flex": mapOrListSelected === PROPERTY_VIEW_STYLE.MAP,
                    "w-full h-full overflow-hidden": mapOrListSelected === PROPERTY_VIEW_STYLE.LIST,
                })}
            >
                <CommunitiesViewList />
            </div>
            <div
                className={cn("relative flex flex-row flex-1", {
                    ["z-1"]: mapOrListSelected === PROPERTY_VIEW_STYLE.MAP,
                    ["w-full md:w-[50%] absolute -z-[100] -left-[150%]"]:
                        mapOrListSelected === PROPERTY_VIEW_STYLE.LIST,
                })}
            >
                <CommunitiesViewMap />
            </div>
            <CommunitiesViewButtonMobile />
        </div>
    );
});
